// API/Components
import { DATA_ERROR_VALUE } from './enums';

// Draw a horizontal dashed line on the provided chart at the specified yValue with the given color
export function DrawHorizontalDashedLine(chart, yValue, color) {
	if (chart !== undefined && yValue !== undefined && yValue > DATA_ERROR_VALUE.INVALID_VALUE) {
		let ctx = chart.ctx;
		let xAxis = chart.scales.x;
		let y = chart.scales.y.getPixelForValue(yValue);

		ctx.save();
		ctx.beginPath();
		ctx.setLineDash([5, 5]);
		ctx.moveTo(xAxis.left, y);
		ctx.lineTo(xAxis.right, y);
		ctx.lineWidth = 1;
		ctx.strokeStyle = color;
		ctx.stroke();
		ctx.restore(); 
	}
}

// Draw a vertical dashed line at the tooltip's x position
export function DrawVerticalDashedLineAtTooltip(chart, color = 'rgba(0, 0, 255, 0.9)') {
	if (chart !== undefined) {
		let ctx = chart.ctx;
		if (chart.tooltip?._active?.length) {
			let x = chart.tooltip._active[0].element.x;
			let yAxis = chart.scales.y;
			ctx.save();
			ctx.beginPath();
			ctx.setLineDash([5, 5]);
			ctx.moveTo(x, yAxis.top);
			ctx.lineTo(x, yAxis.bottom);
			ctx.lineWidth = 1;
			ctx.strokeStyle = color;
			ctx.stroke();
			ctx.restore();
		}
	}
}

// Update chart with new data without triggering a full re-render (preserves zoom/pan)
export function UpdateChartData(chartRef, datasets, labels) {
	if (chartRef && datasets && labels) {
		// Update existing chart (preserves zoom/pan)
		chartRef.current.data.labels = labels;
		chartRef.current.data.datasets = datasets;
		chartRef.current.update('none');
	}
}